<div>
  <div class="kt-portlet__head">
    <div class="kt-portlet__head-progress">
      @if (viewLoading) {
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      }
    </div>
    <div class="kt-portlet__head-label">
      <span class="kt-portlet__head-title">{{data.title | translate}}</span>
      <span class="kt-portlet__head-icon kt-hide">
        <i class="la la-gear"></i>
      </span>
    </div>
  </div>
  <div class="kt-form">
    <div class="kt-portlet__body">
      <div class="flex-row" >
        @if (data.alertType !== alertTypeEnum.SUCCESS) {
          <div  class="error-icon">
            <i class="fas fa-exclamation-circle" style="font-size: 2rem;"></i>
          </div>
        }
        @if (data.alertType === alertTypeEnum.SUCCESS) {
          <div class="success-icon ">
            <i class="fas fa-check-circle" style="font-size: 2rem;"></i>
          </div>
        }
        @if (!data.innerHtml) {
          <div style="align-self: center; max-height: 525px;overflow: auto;" class="scroll-div">
            <span class="UWSlim" style="font-size: 1rem;  font-weight: 700;">
              {{(viewLoading ? data.waitDesciption : data.description) | translate}}
            </span>
          </div>
        }
        @if (data.innerHtml) {
          <div class="form-group kt-form__group row UWSlim"  style="font-size: 1rem;  font-weight: 700;">
            <div [innerHtml]="data.description | safeHtml">
            </div>
          </div>
        }
      </div>
    </div>
    @if (!viewLoading) {
      <div class="kt-portlet__foot kt-portlet__no-border kt-portlet__foot--fit text-right">
        <div class="kt-form__actions kt-form__actions--sm">
          @if (data.singleBtn) {
            <button  (click)="singleBtnClick()" type="button" class="btn btn-primary">
              <span class="kt-hidden-mobile">{{ (data.singleBtnLabel ? data.singleBtnLabel : cancelBtnText) | translate}}</span>
            </button>
          }
          @if (!data.singleBtn) {
            <button mat-button (click)="onNoClick()">{{ (data.cancelBtnLabel ? data.cancelBtnLabel : cancelBtnText) | translate}}</button>
            }&nbsp;
            @if (data.showYesBtn) {
              <button  (click)="onYesClick()" cdkFocusInitial [disabled]="viewLoading" type="button" mat-button color="primary">
                <span class="kt-hidden-mobile">{{data.confirmButton | translate}}</span>
              </button>
            }
          </div>
        </div>
      }
    </div>
  </div>
